<template>
  <div class="addCard">
    <div class="itemCard">
      <div v-if="!personals.length && !isTeam">请完善个人信息</div>
      <div class="lineContent">
        <div class="name">{{isTeam ? '负责人' : '姓名'}}</div>
        <el-input v-model="addDetail.personName" :maxlength="16" placeholder="请输入姓名" :disabled="addDetail.personNameDisabled || addDetail.haveOrder" oninput="if(value.length>20)value=value.slice(0,20)"></el-input>
      </div>
      <!-- 参观人 -->
      <div v-if="addType == 'personal'">
        <div class="lineContent" v-if="!isTeam">
          <div class="name">证件类型</div>
          <el-select v-model="addDetail.cardType" placeholder="请选择" :disabled="addDetail.haveOrder">
            <el-option
              v-for="item in cardTypes"
              :key="item.val"
              :label="item.name"
              :value="item.val">
            </el-option>
          </el-select>
        </div>
        <div v-else class="lineContent">
          <div class="name">团队名称</div>
          <el-input v-model="addDetail.orgName" placeholder="请输入姓名" :disabled="addDetail.haveOrder"></el-input>
        </div>
        <div class="lineContent">
          <div class="name">{{isTeam ? '身份证号' : '证件号码'}}</div>
          <el-input v-model="addDetail.cardNum" placeholder="请输入证件号码" :disabled="addDetail.haveOrder"></el-input>
        </div>
        <div class="lineContent">
          <div class="name">联系电话</div>
          <el-input v-model="addDetail.phone" placeholder="请输入联系电话" type="number" oninput="if(value.length>11)value=value.slice(0,11)" :disabled="addDetail.phoneDisabled || addDetail.haveOrder"></el-input>
        </div>
      </div>
      <div v-if="addType != 'personal'">
        <div class="lineContent">
          <div class="name">年龄(岁)</div>
          <el-input v-model="addDetail.age" placeholder="请输入年龄" type="number" :disabled="addDetail.haveOrder"></el-input>
        </div>
        
        <div class="lineContent" v-if="$store.state.ticketDetail.childCardNumOn">
          <div class="name">身份证号</div>
          <el-input v-model="addDetail.cardNum" placeholder="请输入证件号码" :disabled="addDetail.haveOrder"></el-input>
        </div>
        <div class="lineContent">
          <div class="name">性别</div>
          <el-radio-group v-model="addDetail.gender" :disabled="addDetail.haveOrder">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="tips" v-if="addDetail.haveOrder">该用户有过历史订单，暂不支持修改基本信息</div>
    </div>
    <div class="back" @click="back" v-if="personals.length">返回</div>
    <div class="buttonNormal" @click="saveAddPerson" v-if="!addDetail.haveOrder">保存</div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      // detail: {
      //   name: '',
      //   cardType: '身份证',
      //   card: '',
      //   phone: ''
      // }
    };
  },

  props: ['cardTypes', 'addDetail', 'addType', 'personals', 'isTeam'],

  methods: {
    back() {
      this.$emit('handelShowAdd', false)
    },

    saveAddPerson() {
      this.$emit('saveAddPerson', this.addDetail)
    },

    getDetailInfo() {
      
      this.$ajax.get(`/api/ticket/front/people/get-by-id?id=${this.addDetail.id}`).then((res) =>{
        res = res.data
        // 天津文保
        if (this.$route.query.museumCode == 215314 || this.$route.query.museumCode == 200090) {
          if (this.addDetail.id == this.$cookie.get('belongId')) {
            this.addDetail.phoneDisabled = true
          } else {
            res.haveOrder = false
          }
        } else {
          if (this.addDetail.phone == this.$cookie.get('ticket_phone')) {
            this.addDetail.phoneDisabled = true
          }
        }
        this.$emit('changeAddDetail', res)
      })
    }
  },

  mounted() {
    this.$nextTick(() =>{
      this.addDetail.id ? this.getDetailInfo() : ''
    })
  },

  computed: {
  
  }
}
</script>

<style scoped lang="scss">
  .addCard{
    position: absolute;
    top: 0;
    height: 100vh;
    width: 100%;
    background-color: #fff;
    z-index: 999;
    border-radius: 0.5rem;
    font-size: 0.4rem;
    line-height: 0.8rem;
    .cardImg{
      width: 5rem;
      height: 3rem;
      margin: auto;
      line-height: 2.5rem;
      font-size: 1rem;
      font-weight: 500;
      margin-top: 1rem;
      background: url('~@/assets/idCard.png') 0 0/100% no-repeat;
    }

    .tips{
      font-size: 0.36rem;
      text-align: left;
    }
    .back{
      position: fixed;
      bottom: 1.1rem;
      left: 0.8rem;
      line-height: 0.7rem;
      font-size: 0.4rem;
      border: 1px solid #726a6acc;
      padding: 0rem 0.3rem;
      border-radius: 0.2rem;
      color: #726a6acc;
    }
    .itemCard{
      position: relative;
      margin-bottom: 1rem;
    }
    .buttonNormal{
      position: fixed;
      bottom: 1rem;
    }
    .lineContent .name{
      width: 2.5rem;
    }
  }
</style>
<style type="text/css">
  .addCard .lineContent .el-input__inner{
    width: 6.05rem;
  }
  .addCard .el-radio-group{
    width: 100%;
    text-align: left;
  }
</style>

